import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
export function ContactPage() {
  return <div className="bg-nude-light min-h-screen" data-id="element-266">
      <PageHeader title="Get in Touch" subtitle="We're here to answer your questions and help you find the right care solution." data-id="element-267" />

      <section className="py-20" data-id="element-268">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-269">
          <div className="grid lg:grid-cols-2 gap-16" data-id="element-270">
            {/* Contact Form */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} animate={{
            opacity: 1,
            x: 0
          }} className="bg-white rounded-[2rem] p-8 md:p-10 shadow-soft-lg" data-id="element-271">
              <h2 className="text-3xl font-serif text-chocolate mb-8" data-id="element-272">
                Send Us a Message
              </h2>
              <form className="space-y-6" data-id="element-273">
                <div className="grid md:grid-cols-2 gap-6" data-id="element-274">
                  <div data-id="element-275">
                    <label htmlFor="name" className="block text-sm font-medium text-chocolate/80 mb-2" data-id="element-276">
                      Full Name
                    </label>
                    <input type="text" id="name" className="w-full px-4 py-3 rounded-xl border border-nude bg-nude-light/50 focus:bg-white focus:border-gold focus:ring-2 focus:ring-gold/20 outline-none transition-all" placeholder="John Doe" data-id="element-277" />
                  </div>
                  <div data-id="element-278">
                    <label htmlFor="phone" className="block text-sm font-medium text-chocolate/80 mb-2" data-id="element-279">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" className="w-full px-4 py-3 rounded-xl border border-nude bg-nude-light/50 focus:bg-white focus:border-gold focus:ring-2 focus:ring-gold/20 outline-none transition-all" placeholder="(555) 123-4567" data-id="element-280" />
                  </div>
                </div>

                <div data-id="element-281">
                  <label htmlFor="email" className="block text-sm font-medium text-chocolate/80 mb-2" data-id="element-282">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-xl border border-nude bg-nude-light/50 focus:bg-white focus:border-gold focus:ring-2 focus:ring-gold/20 outline-none transition-all" placeholder="john@example.com" data-id="element-283" />
                </div>

                <div data-id="element-284">
                  <label htmlFor="service" className="block text-sm font-medium text-chocolate/80 mb-2" data-id="element-285">
                    Service of Interest
                  </label>
                  <select id="service" className="w-full px-4 py-3 rounded-xl border border-nude bg-nude-light/50 focus:bg-white focus:border-gold focus:ring-2 focus:ring-gold/20 outline-none transition-all text-chocolate" data-id="element-286">
                    <option value="" data-id="element-287">Select a service...</option>
                    <option value="medical" data-id="element-288">Medical Care</option>
                    <option value="home" data-id="element-289">Home Care</option>
                    <option value="therapy" data-id="element-290">Therapy & Rehab</option>
                    <option value="wellness" data-id="element-291">Wellness Programs</option>
                    <option value="other" data-id="element-292">Other Inquiry</option>
                  </select>
                </div>

                <div data-id="element-293">
                  <label htmlFor="message" className="block text-sm font-medium text-chocolate/80 mb-2" data-id="element-294">
                    Your Message
                  </label>
                  <textarea id="message" rows={5} className="w-full px-4 py-3 rounded-xl border border-nude bg-nude-light/50 focus:bg-white focus:border-gold focus:ring-2 focus:ring-gold/20 outline-none transition-all resize-none" placeholder="How can we help you?" data-id="element-295"></textarea>
                </div>

                <button type="button" className="w-full bg-chocolate text-cream py-4 rounded-full font-bold text-lg hover:bg-gold hover:text-white transition-colors shadow-md" data-id="element-296">
                  Send Message
                </button>
              </form>
            </motion.div>

            {/* Contact Info */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} animate={{
            opacity: 1,
            x: 0
          }} className="flex flex-col justify-center" data-id="element-297">
              <h2 className="text-3xl font-serif text-chocolate mb-8" data-id="element-298">
                Contact Information
              </h2>
              <p className="text-lg text-chocolate/80 mb-10 leading-relaxed" data-id="element-299">
                Whether you're ready to start care or just exploring your
                options, our team is here to provide guidance and support.
              </p>

              <div className="space-y-8" data-id="element-300">
                <div className="flex items-start gap-4" data-id="element-301">
                  <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center text-gold shrink-0" data-id="element-302">
                    <MapPin size={24} data-id="element-303" />
                  </div>
                  <div data-id="element-304">
                    <h3 className="font-bold text-chocolate mb-1" data-id="element-305">
                      Our Location
                    </h3>
                    <p className="text-chocolate/70" data-id="element-306">
                      123 Wellness Way, Suite 100
                      <br data-id="element-307" />
                      Healthcare City, HC 90210
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-308">
                  <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center text-gold shrink-0" data-id="element-309">
                    <Phone size={24} data-id="element-310" />
                  </div>
                  <div data-id="element-311">
                    <h3 className="font-bold text-chocolate mb-1" data-id="element-312">
                      Phone Number
                    </h3>
                    <p className="text-chocolate/70" data-id="element-313">
                      <a href="tel:+15551234567" className="hover:text-gold transition-colors" data-id="element-314">
                        (555) 123-4567
                      </a>
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-315">
                  <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center text-gold shrink-0" data-id="element-316">
                    <Mail size={24} data-id="element-317" />
                  </div>
                  <div data-id="element-318">
                    <h3 className="font-bold text-chocolate mb-1" data-id="element-319">
                      Email Address
                    </h3>
                    <p className="text-chocolate/70" data-id="element-320">
                      <a href="mailto:hello@crownehealth.com" className="hover:text-gold transition-colors" data-id="element-321">
                        hello@crownehealth.com
                      </a>
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-322">
                  <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center text-gold shrink-0" data-id="element-323">
                    <Clock size={24} data-id="element-324" />
                  </div>
                  <div data-id="element-325">
                    <h3 className="font-bold text-chocolate mb-1" data-id="element-326">
                      Hours of Operation
                    </h3>
                    <p className="text-chocolate/70" data-id="element-327">
                      Monday - Friday: 8:00 AM - 6:00 PM
                      <br data-id="element-328" />
                      Saturday - Sunday: 9:00 AM - 2:00 PM
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Map Placeholder */}
      <section className="pb-20" data-id="element-329">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-330">
          <div className="w-full h-96 bg-nude rounded-[2rem] overflow-hidden relative shadow-inner flex items-center justify-center" data-id="element-331">
            {/* Simulated map appearance */}
            <div className="absolute inset-0 opacity-20" style={{
            backgroundImage: 'radial-gradient(#C9A96E 1px, transparent 1px)',
            backgroundSize: '20px 20px'
          }} data-id="element-332"></div>
            <div className="relative z-10 text-center" data-id="element-333">
              <MapPin size={48} className="text-chocolate mx-auto mb-4" data-id="element-334" />
              <p className="text-chocolate font-serif text-xl" data-id="element-335">
                Interactive Map Placeholder
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Simple Footer CTA */}
      <section className="py-16 bg-chocolate text-center" data-id="element-336">
        <div className="max-w-3xl mx-auto px-4" data-id="element-337">
          <h2 className="text-3xl font-serif text-cream mb-4" data-id="element-338">
            Ready to take the next step?
          </h2>
          <p className="text-cream/80 mb-8" data-id="element-339">
            Our care coordinators are standing by to assist you.
          </p>
          <a href="tel:+15551234567" className="inline-block bg-gold text-chocolate px-8 py-4 rounded-full font-bold text-lg hover:bg-white transition-colors shadow-lg" data-id="element-340">
            Call Us Now
          </a>
        </div>
      </section>
    </div>;
}